export default "__VITE_PUBLIC_ASSET__69715480__"